import { useQuery } from "@tanstack/react-query";
import { supabase } from "../lib/supabaseClient";

export const useSavedRecs = (userId) => {
  return useQuery({
    queryKey: ['savedRecs', userId],
    queryFn: async () => {
      if (!userId) return [];
      const { data, error } = await supabase
        .from("user_recommendations")
        .select("recommendation_id")
        .eq("user_id", userId);
      if (error) throw error;
      return data.map((r) => r.recommendation_id);
    },
    enabled: !!userId,
  });
};
